import styled from 'styled-components';
import { StyledProductItem } from '../../listItemStyle';

export const Wrapper = styled(StyledProductItem)`
  padding: 20px 24px !important;
`;
